import { render, staticRenderFns } from "./PageEditorModified.vue?vue&type=template&id=02c66689&scoped=true"
import script from "./PageEditorModified.vue?vue&type=script&lang=js"
export * from "./PageEditorModified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c66689",
  null
  
)

export default component.exports